interface AutoSuggestion {
    qualifiers: string[]
    text: string[]
}

export default [
    {
        qualifiers: ['make'],
        text: ['make:chevy', 'make:chevy,ford,gmc'],
    },
    {
        qualifiers: ['model'],
        text: ['model:F150', 'model:silverado,f150,sierra'],
    },
    {
        qualifiers: ['color'],
        text: ['color:green', 'color:green,silver,black'],
    },
    { qualifiers: ['cr'], text: ['cr:yes', 'cr:no'] },
    { qualifiers: ['photos'], text: ['photos:5', 'photos:0', 'photos<10'] },
    {
        qualifiers: ['floor'],
        text: ['floor:10000', 'floor>10000', 'floor<10000'],
    },
    { qualifiers: ['mmr'], text: ['mmr:10000', 'mmr>10000', 'mmr<10000'] },
    {
        qualifiers: ['blackbook'],
        text: ['blackbook:10000', 'blackbook>10000', 'blackbook<10000'],
    },
    { qualifiers: ['lotdays'], text: ['lotdays:30'] },
    {
        qualifiers: ['sourcetype', 'data', 'feed'],
        text: ['sourcetype:dms', 'data:ams', 'feed:all'],
    },
    { qualifiers: ['stock'], text: ['stock:1234567', 'stock:100000-200000'] },
    {
        qualifiers: ['saledate', 'sd'],
        text: ['saledate:10', 'saledate:5+', 'sd:7-14'],
    },
    {
        qualifiers: ['checkindate', 'cd'],
        text: ['checkindate:3', 'checkindate:3+', 'cd:7-14'],
    },
    { qualifiers: ['randate', 'rd'], text: ['randate:15', 'rd:7+'] },
    { qualifiers: ['lane'], text: ['lane:1x'] },
    { qualifiers: ['run'], text: ['run:1x-30'] },
    {
        qualifiers: ['status'],
        text: ['status:sold', 'status:inventory', 'status:offer', 'status:arbitration,consigned,in-sale'],
    },
    {
        qualifiers: ['saletype', 'method', 'venue', 'biddertype', 'salemethod'],
        text: ['saletype:lane', 'saletype:online', 'method:lane', 'biddertype:online'],
    },
    { qualifiers: ['source'], text: ['source:eblock'] },
    { qualifiers: ['accountId'], text: ['accountId:G00001'] },
    {
        qualifiers: ['account'],
        text: ['account:"GM Financial"', 'account:"H D\'s Auto"'],
    },
    { qualifiers: ['buyer'], text: ['buyer:herron'] },
    { qualifiers: ['seller'], text: ['seller:warren'] },
    {
        qualifiers: ['buyerid'],
        text: ['buyerid:A00950', 'buyerid:A00950,A00393'],
    },
    {
        qualifiers: ['sellerid', 'consignorid'],
        text: ['sellerid:A00403', 'sellerid:B00534'],
    },
    { qualifiers: ['city'], text: ['city:seattle', 'city:seattle,tacoma'] },
    { qualifiers: ['state'], text: ['state:WA', 'state:WA,NC,TN,FL'] },
    { qualifiers: ['zip', 'postal'], text: ['zip:12345', 'postal:12345,12333'] },
    { qualifiers: ['establishdate'], text: ['establishdate:30'] },
    { qualifiers: ['sellertype'], text: ['sellertype:UC', 'sellertype:UC,NC'] },
    { qualifiers: ['buyertype'], text: ['buyertype:UC', 'buyertype:UC,NC'] },
    {
        qualifiers: ['NOTbuyerId'],
        text: ['NOTbuyerId:G00001', 'NOTbuyerId:G00001,H00001'],
    },
    {
        qualifiers: ['NOTsellerId'],
        text: ['NOTsellerId:G00001', 'NOTsellerId:G00001,H00001'],
    },
    {
        qualifiers: ['NOTaccountId'],
        text: ['NOTaccountId:G00001', 'NOTaccountid:G00001,H00001'],
    },
    {
        qualifiers: ['notbuyertype', 'buyertypenot'],
        text: ['NOTbuyerType:UC', 'NOTbuyerType:UC,NC'],
    },
    {
        qualifiers: ['notsellertype', 'sellertypenot'],
        text: ['NOTsellerType:NC', 'NOTsellertype:UC,NC'],
    },
    {
        qualifiers: ['bb', 'bidder', 'badge'],
        text: ['bb:101', 'bidder:101', 'badge:101'],
    },
    { qualifiers: ['fav', 'favorite'], text: ['fav:yes'] },
    {
        qualifiers: ['rep', 'salesrep'],
        text: ['rep:cb', 'salesrep:"john smith"'],
    },
    {
        qualifiers: ['repnot', 'salesrepnot'],
        text: ['repnot:cb', 'salesrepnot:"john smith"'],
    },
    {
        qualifiers: ['repbuyer'],
        text: ['repbuyer:cb', 'repbuyer:"john smith"'],
    },
    {
        qualifiers: ['repseller'],
        text: ['repseller:cb', 'repseller:"john smith"'],
    },
    {
        qualifiers: ['title'],
        text: ['title:yes', 'title:no'],
    },
    {
        qualifiers: ['buyeragentid', 'bid'],
        text: ['bid:101', 'buyeragentid:101'],
    },
    {
        qualifiers: ['psi'],
        text: ['psi:yes', 'psi:no'],
    },
    {
        qualifiers: ['psisource'],
        text: ['psisource:spark', 'psisource:ams', 'psisource:pipeline'],
    },
    // {
    //   qualifiers: ['psitype'],
    //   text: ['psitype:<??>', 'psitype:<??>']
    // },
] as AutoSuggestion[]
